import {Component, Input} from '@angular/core';
import {UserRolesEnum} from '../../../users/models/user';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent {

  @Input('role') role: UserRolesEnum;

  constructor() { }
}
